import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient, updateClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { UserTypes } from "../../enum/UserTypes";
import { useNavigate } from "react-router-dom";
import { removeEmployee, updateEmployee } from "../../service/employeeService";
import { siteEmployeeRemove } from "../../service/siteService";
import SubContractorSiteAdd from "./SubContractor-Site-Add";

export default function SubContractorSiteTable(props: RouteComponentProps) {
  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = "sub-contractor-site";

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    active: { value: true, matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    removeClient(selectedRecord.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRecord(null);
    // props.setGlobalLoader(true);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    setSelectedRecord(value);
    viewSelected(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await siteEmployeeRemove(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: "Employee Deleted Successfully",
      life: 3000,
    });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await updateEmployee({ active: status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: status ? "Employee Activated Successfully" : "Employee Deactivated Successfully",
      life: 3000,
    });
  };

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to deactivate employee?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(false),
    });
  };

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to activate employee?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(true),
    });
  };

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  };

  const viewSelected = (row: any) => {
    setVisible(true);
  };

  const contextItems = () => {
    let objArray = [
      { label: "Edit", icon: "pi pi-fw pi-pencil", command: viewSelected },
      // { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: DialogSetVisible },
    ];
    if (selectedRecord?.active) {
      objArray.push({
        label: "Deactivate",
        icon: "pi pi-fw pi-times-circle",
        command: disableConfirm,
      });
    } else {
      objArray.push({
        label: "Activate",
        icon: "pi pi-fw pi-check-circle",
        command: activateConfirm,
      });
    }
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Site",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "active",
      header: "Active",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "appointment_list",
      header: "Appointment",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "compliance_status",
      header: "Compliance Status",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
  ];

  return (
    <React.Fragment>
      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        queryParams={{ subcontractorId: props.subContractor?.id || "" }}
        url={url}
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        header={selectedRecord?.id ? "Update Site" : "Add Site"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        draggable={false}
      >
        <SubContractorSiteAdd
          setGlobalLoading={props.setGlobalLoader}
          record={selectedRecord}
          setReload={setReload}
          reload={reload}
          setVisible={setVisible}
          toast={toast}
          session={props.session}
          subContractor={props.subContractor?.id || ""}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
